/*
 * @Author: cc
 * @Date: 2020-01-11 12:23:45
 * @LastEditTime : 2020-01-11 19:45:06
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\editingCenter\app\service\activityOrAdvertising\activityOrAdvertising.js
 * @Description: 选择广告或者活动
 */
angular.module('appActivityOrAdvertisingModule', []).controller('appActivityOrAdvertisingCtrl', [
    '$scope',
    '$modalInstance',
    '$filter',
    'params',
    'editingCenterAppService',
    'globleParamsSet',
    function($scope, $modalInstance, $filter, params, editingCenterAppService, globleParamsSet) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                keywords: '', // 搜索关键词
            };
            $scope.data = {
                title: '',
                items: [],
                selectedItem: {},
                copyItems: [], // 复制数据为了前端假检索
            };
        }

        /**
         * [initData description] 初始化方法
         * @return  {[type]}  [return description]
         */
        function initData() {
            activityOrAdvertising();
        }

        /**
         * [getActivity description]获取活动或者广告
         * @return  {[type]}  [return description]
         */
        function activityOrAdvertising() {
            editingCenterAppService.getActivityOrAdvertisement(params.methodName).then((data) => {
                $scope.data.items = data;
                $scope.data.copyItems = angular.copy($scope.data.items);
            });
        }

        /**
         * [confirm description] 确定操作
         * @return  {[type]}  [return description]
         */
        $scope.confirm = function() {
            // $scope.data.selectedItem.LISTPICS = [
            //     {
            //         APPDESC: 'W020200111622849363376.jpeg',
            //         APPFILE: 'W020200111622849363376.jpeg',
            //         SRCPICURL: 'http://devxjy.xinbeiting.com/webpic/W0202001/W020200111/W020200111622849363376.jpeg',
            //     },
            //     {
            //         APPDESC: 'W020200111622849363376.jpeg',
            //         APPFILE: 'W020200111622849363376.jpeg',
            //         SRCPICURL: 'http://devxjy.xinbeiting.com/webpic/W0202001/W020200111/W020200111622849363376.jpeg',
            //     },
            // ];
            $modalInstance.close($scope.data.selectedItem);
        };

        /**
         * [dismiss description] 取消操作
         * @return  {[type]}  [return description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [select description] 选择活动或者广告
         * @param   {[object]}  item  [item description] 活动或者广告
         * @return  {[type]}          [return description]
         */
        $scope.select = function(item) {
            $scope.data.selectedItem = item;
        };

        /**
         * [search description] 检索字段
         * @param   {[object]}  event  [event description] 事件对象
         * @return  {[type]}           [return description]
         */
        $scope.search = function(event) {
            globleParamsSet.searchByWord(event).then((data) => {
                if ($scope.status.keywords) {
                    $scope.data.items = $filter('filterBy')($scope.data.copyItems, ['TITLE'], $scope.status.keywords);
                } else {
                    $scope.data.items = $scope.data.copyItems;
                }
            });
        };
    },
]);
